const copy = async (text: string): Promise<boolean> => {
  if (!navigator.clipboard) {
    // Clipboard API is not available
    return false;
  }

  try {
    await navigator.clipboard.writeText(text);
  } catch {
    return false;
  }

  return true;
};

export const useClipboard = (
  initialText: string,
): {
  copyText: (text?: string) => Promise<boolean>;
} => {
  return {
    copyText: async (text = initialText): Promise<boolean> => {
      const didCopy = await copy(text);

      return didCopy;
    },
  };
};
